import { jsx as _jsx } from "react/jsx-runtime";
import { Button, LinkTarget, IconName, IconSize, ButtonVariant, ButtonSize, Group, GroupAlign } from '@as/cotopaxi';
export const ProductCareCTA = ({ alt, buttonVariant, label, linkPath, targetIsBlank, horizontalAlign, }) => {
    const isLinkStyle = buttonVariant === ButtonVariant.LINK || buttonVariant === ButtonVariant.LINK_SUBTLE;
    return (_jsx(Group, { align: horizontalAlign || GroupAlign.CENTER, children: _jsx(Button, { variant: buttonVariant, size: isLinkStyle ? ButtonSize.SMALL : ButtonSize.NORMAL, href: linkPath, target: targetIsBlank ? LinkTarget.BLANK : null, text: label, title: alt, iconRight: {
                name: IconName.CHEVRON_RIGHT,
                size: IconSize.MINOR,
            } }) }));
};
